import { ReactNode, useState } from "react";
import { Colors, IconName, Classes, Icon } from "@blueprintjs/core";
import { quarks, Box } from "ui-components";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import useSession from "ui-io/use-session";
import { formatLocation } from "../routes";

type LinkT = {
	id: string;
	title: string;
	icon: IconName;
	url: string;
	isAdminOnly?: boolean;
	envs?: string[];
};

const TaskLayout = ({ children }: { children: ReactNode }) => {
	const { session } = useSession();

	const isAdmin = session?.role === "ADMIN_MANAGER" || session?.role === "SUPER_ADMIN"
	/** Webpack does not allow us to have these links out of the component*/
	const [subRouteLinks] = useState<LinkT[]>([
		{
			id: "pending",
			title: "Pending",
			icon: "list",
			url: formatLocation.taskPending({}),
			isAdminOnly: true,
		},{
			id: "inbox",
			title: "Inbox",
			icon: "inbox",
			url: formatLocation.taskInbox({}),
		},
		{
			id: "in-progress",
			title: "In-Progress",
			icon: "time",
			url: formatLocation.taskInProgress({}),
		},
		{
			id: "approved",
			title: "Approved",
			icon: "tick-circle", 
			url: formatLocation.taskApproved({}),
		},
		{
			id: "peer-review",
			title: "Peer Review",
			icon: "team", 
			url: formatLocation.taskPeerReview({}),
			isAdminOnly: true,
		},
		{
			id: "rejected",
			title: "Rejected",
			icon: "cross-circle", 
			url: formatLocation.taskRejected({}),
		}
	]);

	return (
		<>
			<SubRouteBar>
				{subRouteLinks.map((link) => {
					const { id, url, icon, title, isAdminOnly} = link;
					if( isAdminOnly && !isAdmin) {
						return null;
					}
					return (
						<NavLink
							key={id}
							to={url}
							className={({ isActive }) =>
								`${Classes.BUTTON} ${Classes.MINIMAL}${isActive ? ` ${Classes.INTENT_PRIMARY}` : ""}`
							}
						>
							<Box flexDir="row" items="center">
								<Icon
									icon={icon}
									style={{ marginRight: quarks.margins.small }}
									iconSize={14}
								/>
								<span>{title}</span>
							</Box>
						</NavLink>
					);
				})}
			</SubRouteBar>
			<TaskPageWrapper>{children}</TaskPageWrapper>
		</>
	);
};

const TaskPageWrapper = styled.div`
	height: 100%;
	padding-top: 50px;
`;

const SubRouteBar = styled.div`
	height: 50px;
	position: fixed;
	top: 50px;
	margin: 0 -40px;
	padding: 8px 30px;
	width: 100%;
	background-color: ${(props) => {
		return props.theme.darkMode ? Colors.DARK_GRAY2 : Colors.LIGHT_GRAY5;
	}};
	border-top: 1px solid
		${(props) => {
			return props.theme.darkMode ? Colors.DARK_GRAY4 : Colors.LIGHT_GRAY4;
		}};
	border-bottom: 1px solid
		${(props) => {
			return props.theme.darkMode ? Colors.DARK_GRAY4 : Colors.LIGHT_GRAY4;
		}};
	/** Without this property all <Select /> elements are placed above the bar. */
	z-index: 15;
`;

export default TaskLayout;
